import PatientService from 'Services/PatientService'
import IssueService from 'Services/IssueService'
import EventService from 'Services/EventService'

const initialState = {
    patient: {
        id: null,
        physiotherapist_id: null,
        first_name: '',
        last_name: '',
        pesel: '',
        born_date: '',
        gender: null,
        address_street: '',
        address_postcode: '',
        address_city: '',
        email: '',
        phone: '',
        contact_person_first_name: '',
        contact_person_last_name: '',
        contact_person_address_street: '',
        contact_person_address_postcode: '',
        contact_person_address_city: '',
        contact_person_email: '',
        contact_person_phone: ''
    },
    events: {
        data: [],
        last_page: 1,
        per_page: 5,
        current_page: 1
    },
    issues: {
        data: [],
        last_page: 1,
        per_page: 5,
        current_page: 1
    }
}

export default {

    namespaced: true,

    state: Object.assign({}, initialState),

    getters: {
        patient: state => state.patient,
        issues: state => state.issues,
        events: state => state.events
    },

    mutations: {
        SET_PATIENT(state, patient) {
            state.patient = patient
        },
        SET_ISSUES(state, issues) {
            state.issues = issues
        },
        SET_EVENTS(state, events) {
            state.events = events
        },
    },

    actions: {
        FETCH_PATIENT({commit}, patientId) {
            return PatientService.get(patientId).then((response) => {
                commit('SET_PATIENT', response.data.data)
                return response
            })
        },
        REMOVE_PATIENT(context, patientId) {
            return PatientService.delete(patientId)
        },
        FETCH_ISSUES({commit}, payload) {
            return IssueService.list({
                patient_id: payload.id,
                paginate: 1,
                page: payload.page
            }).then((result) => {
                commit('SET_ISSUES', result.data.data)
                return result
            })
        },
        FETCH_EVENTS({commit}, payload) {
            return EventService.list({
                patient_id: payload.id,
                with: 'office',
                has_visit: 0,
                paginate: 1,
                page: payload.page
            }).then((result) => {
                commit('SET_EVENTS', result.data.data)
                return result
            })
        },
        PATIENT_RESET(context) {
            context.commit('RESET_STATE')
        }
    }

}
